import { Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';

import logo from 'assets/png/hello-hive-logo.png';
import authorizationCreator from 'store/authorization/actions';

import LoginForm from './login-form';
import { Container, Wrapper, Image } from './styled';
import validationSchema from './validation-schema';

const Login = () => {
  const dispatch = useDispatch();

  const handleSubmit = values => dispatch(authorizationCreator.authLoginRequest(values.email, values.password));

  return (
    <Container>
      <div>
        <Image src={logo} alt="Hive 5" />
      </div>
      <p style={{ color: 'grey' }}>For Employers</p>
      <Wrapper>
        <Formik
          component={LoginForm}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnBlur={false}
          initialValues={{ email: '', password: '' }}
        />
      </Wrapper>
    </Container>
  );
};

export default Login;
